import { APIResponseType, createThunkCase } from "@/redux/helper/thunk";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { thunks } from "./thunk";
import { AsyncThunk } from "@reduxjs/toolkit";

interface APTStateType {
  getRFQDetails: APIResponseType;
}

const APIState: APTStateType = {
  getRFQDetails: {
    data: null,
    loading: false,
    meta: null,
  }
};

const initialState = {
  ...APIState,
} satisfies APTStateType as APTStateType;

export const slice = createSlice({
  name: "user_buyer_rfq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    Object.entries(thunks).forEach(([_, thunk]) => {
      createThunkCase(builder, thunk as AsyncThunk<any, any, any>, APIState);
    });
  },
});

export const Actions = slice.actions;
export default slice.reducer;